import { UserOrganisationType } from "@/api/query/useOrganisationDetailsQuery";
import UserAvatar from "@/components/ui/userAvatar";
import dateFormater from "@/helperFuntions/dateFormater";
import DiamondIcon from "../../../assets/svg/DiamondIcon.svg";
import EditNewSvg from "../../../assets/svg/editNew.svg";
import ParentTaskIcon from "../../../assets/svg/ParentTaskIcon.svg";
import { ExtendedKanbanDataSource } from "./index";
import PercentageCircle from "@/components/shared/PercentageCircle";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Edit from "../../../assets/svg/EditPen.svg";
import TrashCan from "../../../assets/svg/TrashCan.svg";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "react-i18next";
import {  useMemo } from "react";
import { UserRoleEnumValue } from "@backend/src/schemas/enums";
import Calendar from "@/assets/v2/svg/CalendarIcon.svg";
function TaskShellView(props: {
  taskData: ExtendedKanbanDataSource;
  open: (id: string | undefined) => void;
  remove: (id: string | undefined) => void;
}) {
  const users: UserOrganisationType[] = useMemo(
    () => JSON.parse(props.taskData?.users ?? "[]"),
    [props.taskData?.users]
  );
  const allowed: ("edit" | "delete")[] = useMemo(() => {
    const allowedActions: ("edit" | "delete")[] = [];
    if (
      (props.taskData &&
        props.taskData.organisationRole == UserRoleEnumValue.ADMINISTRATOR) ||
      props.taskData.projectRole == UserRoleEnumValue.PROJECT_MANAGER ||
      props.taskData.projectRole == UserRoleEnumValue.ADMINISTRATOR
    ) {
      allowedActions.push("edit", "delete");
    } else if (
      props.taskData &&
      props.taskData.projectRole == UserRoleEnumValue.TEAM_MEMBER &&
      props.taskData.createdByUserId == props.taskData.loginUserId
    ) {
      allowedActions.push("edit", "delete");
    } else if (
      props.taskData &&
      props.taskData.projectRole == UserRoleEnumValue.TEAM_MEMBER &&
      users.find(
        (taskUser) => taskUser.user.userId == props.taskData.loginUserId
      )
    ) {
      allowedActions.push("edit");
    }
    return allowedActions;
  }, [props.taskData, users]);

  const {t}=useTranslation();
  return (
    <div className="w-full h-full p-2 pl-0 flex items-center border-2 border-[#DEE1E6] rounded-lg gap-0.5">
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <div
              className={`w-1 h-full border-l-4  ${
                props.taskData?.color == "#008000"
                  ? "border-l-flag-green"
                  : props.taskData?.color == "#FF0000"
                  ? "border-l-flag-red"
                  : props.taskData?.color == "#FFA500"
                  ? "border-l-flag-orange"
                  : ""
              }`}
            ></div>
          </TooltipTrigger>
          <TooltipContent>
            {props.taskData?.color == "#008000"
              ? "On time"
              : props.taskData?.color == "#FF0000"
              ? "Significant delay"
              : props.taskData?.color == "#FFA500"
              ? "Moderate delay"
              : ""}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <div className={`w-full h-full px-2`}>
        <div className="flex justify-between items-center w-full">
          <div className="text-lg text-gray-500 flex items-center gap-1 w-full">
            <div className=" w-full text-[#0D062D]  truncate">
              <div className="font-normal truncate text-[#0D062D]/20 !text-xs">
                {props.taskData.parentTask}
              </div>
              <TooltipProvider delayDuration={0}>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="block w-[17ch] truncate gap-2 !text-sm">
                      {props.taskData?.text}
                    </div>
                  </TooltipTrigger>
                  {props.taskData?.text &&
                    props.taskData?.text?.length > 17 && (
                      <TooltipContent className="w-[30ch] h-auto whitespace-normal truncate  break-normal ">
                        {props.taskData.text}
                      </TooltipContent>
                    )}
                </Tooltip>
              </TooltipProvider>
            </div>
            {props.taskData.mileStone && (
              <img src={DiamondIcon} className="w-3 h-3 mt-2" />
            )}
            <div>
              <PercentageCircle
                percentage={props.taskData.progress ?? 0}
                className="text-xs"
                roundColor={`${
                  props.taskData?.color == "#008000"
                    ? "#34D399"
                    : props.taskData?.color == "#FF0000"
                    ? "#FB7185"
                    : props.taskData?.color == "#FFA500"
                    ? "#FBBF24"
                    : ""
                } `}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col text-gray-450 justify-between ">
          {props.taskData?.dueDate && (
            <div className="flex gap-1 items-center ">
              <img src={Calendar} className=" w-3.5 h-3.5" alt="" />
              <div className="!text-xs">
              {t("due_date")}:{dateFormater(props.taskData?.dueDate)}
              </div>
            </div>
          )}
          <div className="flex items-center gap-1 mt-1">
            {props.taskData.subTask > 0 && (
              <div className="flex gap-1 ">
                <img src={ParentTaskIcon} className="w-4 h-4 opacity-50" />
              </div>
            )}
            {props.taskData?.subTask > 0 ? props.taskData?.subTask : ""}
            <div className="w-full flex items-center justify-between ">
              <div className="w-14 grid grid-cols-[repeat(auto-fit,minmax(10px,max-content))] mr-2">
                {users.slice(0, 3).map((item, index) => {
                  const zIndex = Math.abs(index - 2);
                  return (
                    <div
                      className="flex items-center text-gray-450"
                      key={index}
                      style={{ zIndex: zIndex }}
                    >
                      <UserAvatar
                        className={`shadow-sm w-6 h-6  border border-white`}
                        fontClass="!text-xs font-semibold"
                        user={item.user}
                      ></UserAvatar>
                    </div>
                  );
                })}
                {users && users?.length > 3 && (
                  <div className="bg-gray-200/30 w-8  text-lg font-medium h-8 rounded-full flex justify-center items-center">
                    {`${users.length - 3}+`}
                  </div>
                )}
              </div>
              <div className="">
                {allowed.length >= 1 && (
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <div className="">
                        <img
                          src={EditNewSvg}
                          className="mr-2 h-4 w-4 "
                          alt=""
                        />
                      </div>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className="w-full text-xs flex flex-col gap-1 bg-white shadow rounded">
                      {allowed.includes("edit") && (
                        <DropdownMenuItem
                          className="cursor-pointer"
                          onClick={() =>
                            props.open(
                              props.taskData.id
                                ? props.taskData.id?.toString()
                                : ""
                            )
                          }
                        >
                          <img
                            src={Edit}
                            className="mr-2 h-3 w-3 invert "
                            alt=""
                          />
                          <span className="p-0 font-normal text-xs h-auto">
                            {t("view_tasks")}
                          </span>
                        </DropdownMenuItem>
                      )}
                      {allowed.includes("delete") && (
                        <DropdownMenuItem
                          className="cursor-pointer"
                          onClick={() =>
                            props.remove(
                              props.taskData.id
                                ? props.taskData.id?.toString()
                                : ""
                            )
                          }
                        >
                          <img
                            src={TrashCan}
                            className="mr-2 h-4 w-4 text-[#44546F]"
                          />
                          <span className="p-0 font-normal text-xs h-auto text-red-500">
                            {t("remove")}
                          </span>
                        </DropdownMenuItem>
                      )}
                    </DropdownMenuContent>
                  </DropdownMenu>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TaskShellView;
